var _rect, _path, _g, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 56,
    height: 56,
    rx: 8,
    fill: "#AFF3E6"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 21,
    width: 39,
    height: 27
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m17.94 21.94-7.8 5.55a1.7 1.7 0 0 0-.23 2.58L27.18 47.4a1.7 1.7 0 0 0 2.4 0L46.8 30.06a1.7 1.7 0 0 0-.21-2.58l-7.76-5.55a1.7 1.7 0 0 0-.99-.32h-18.9c-.36 0-.7.11-1 .32Z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.38 48.5 48.2 28.56H36.44L28.38 48.5Z",
    fill: "#058E74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m48.2 28.56-9.28-6.65a2.06 2.06 0 0 0-1.2-.38h-5.34l4.06 7.03H48.2Z",
    fill: "#41BFA7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.38 48.5-8.12-19.94h16.18L28.38 48.5Z",
    fill: "#005948"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.26 28.56 4.24-7.03h7.88l4.06 7.03H20.26Z",
    fill: "#017C65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 28.56 28.38 48.5l-8.12-19.94H8.5Z",
    fill: "#058E74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.84 21.91 8.5 28.56h11.76l4.24-7.03h-5.46c-.43 0-.85.13-1.2.38Z",
    fill: "#41BFA7"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 13.57a1.33 1.33 0 1 0-1.9 1.86l1.9-1.86Zm.16 3.98a1.33 1.33 0 0 0 1.91-1.86l-1.91 1.86Zm-2.06-2.12 2.06 2.12 1.91-1.86-2.06-2.12-1.91 1.86ZM40.76 13.57a1.33 1.33 0 1 1 1.92 1.86l-1.92-1.86Zm-.15 3.98a1.33 1.33 0 0 1-1.9-1.86l1.9 1.86Zm2.07-2.12-2.07 2.12-1.9-1.86 2.05-2.12 1.92 1.86ZM27.1 10.52a1.33 1.33 0 0 1 2.66-.04l-2.67.04Zm2.7 2.92a1.33 1.33 0 0 1-2.67.04l2.67-.04Zm-.04-2.96.04 2.96-2.67.04-.04-2.96 2.67-.04Z",
    fill: "#54CDB6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(8.5 8.5)",
    d: "M0 0h40v40H0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.384034570dcc08c435910762cd7fffb7.svg";
export { ForwardRef as ReactComponent };